
import { Component, Injector, Input, OnInit } from '@angular/core';
import { BasePermissionService } from 'tnx-admin-service/authorization/basepermission/services';
import { ModuleService } from 'tnx-admin-service/authorization/module/services';
import {
    ComponentContextService, DataFormBase, EventData, FormSchemaBase, TextControlSchema,
    SwitchControlSchema, DateTimeControlSchema, DropdownControlSchema, TextAreaControlSchema, ButtonControlSchema
} from 'tnx-shared';

@Component({
    selector: 'basepermission-form',
    templateUrl: './basepermission-form.component.html',
    styleUrls: ['./basepermission-form.component.scss'],
    providers: [ComponentContextService],
})
export class BasePermissionFormComponent extends DataFormBase implements OnInit {
    constructor(
        protected _injector: Injector,
        private _basePermissionService: BasePermissionService,
        private _moduleService: ModuleService
    ) {
        super(_injector);
    }

    ngOnInit() {
        this.setting.baseService = this._basePermissionService;
        this.setting.schema = <FormSchemaBase[]>[
            new TextControlSchema({
                field: 'code',
                label: 'Mã',
                required: true
            }),
            new TextControlSchema({
                field: 'name',
                label: 'Tên',
                required: true
            }),
            new DropdownControlSchema({
                field: 'moduleCode',
                label: 'Phân hệ',
                baseService: this._moduleService,
                required: true,
                filter: true,
                valueField: 'code',
                displayField: 'name'
            }),
            new TextControlSchema({
                field: 'orderNo',
                label: 'Thứ tự',
                dataFormat: 'number'
            }),
            new TextAreaControlSchema({
                field: 'description',
                label: 'Mô tả',
                mdWidth: 12
            })
        ];
        super.ngOnInit();
    }

    async onFormInitialized(formEvent: EventData) {
        // tiền xử lý dữ liệu (ví dụ tổng hợp datasource), trước khi gọi api get detail
    }

    async onBeforeSave() {
        // trước khi lưu
        return true;
    }
}

